//#region src/worldpay_gift_card_type.ts
var WorldpayGiftCardType = /* @__PURE__ */ function(WorldpayGiftCardType) {
	WorldpayGiftCardType["Vantiv"] = "vantiv";
	WorldpayGiftCardType["StoreCard"] = "storeCard";
	return WorldpayGiftCardType;
}(WorldpayGiftCardType || {});
//#endregion
export { WorldpayGiftCardType };

//# sourceMappingURL=worldpay_gift_card_type.js.map